import PropTypes from 'prop-types';
export const featureContentPropTypes = {
  /**
   * Heading content
   */
  heading: PropTypes.string,
  /**
   * Text content
   */
  text: PropTypes.string,
  /**
   * Variant options
   */
  variant: PropTypes.arrayOf(PropTypes.oneOf(['White', 'White2', 'Beige', 'Wave', 'PictureOnLeft'])),
  /**
   * Actions elements
   */
  actions: PropTypes.shape({
    button: PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string
    }),
    newsletterForm: PropTypes.shape({
      placeholder: PropTypes.string,
      label: PropTypes.string,
      info: PropTypes.string,
      classname: PropTypes.string,
      onSubscribe: PropTypes.func,
      consent: PropTypes.string
    })
  }),
  button: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string
  }),
  /**
   * Subheading over heading
   */
  subheading: PropTypes.string,
  /**
   * Picture 
   */
  picture: PropTypes.shape({
    xs: PropTypes.string,
    sm: PropTypes.string,
    alt: PropTypes.string
  })
};